import {Component, Input, OnInit} from '@angular/core';
import {CampaignForm} from '@app/@core/advertising/campaign/campaign-form';
import {CampaignDraft} from "@app/@core/advertising/campaign/campaign-draft";
import {ConfigService} from "@app/@core/@config/config.service";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-campaign-state[campaignForm]',
  templateUrl: './campaign-state.component.html',
  styleUrls: ['./campaign-state.component.scss']
})
export class CampaignStateComponent implements OnInit {
  @Input() campaignForm!: FormGroup;

  constructor(public configService: ConfigService) { }

  ngOnInit(): void {
  }
}
